import React, { Component } from 'react'
import classnames from 'classnames'
import { reduxForm } from 'redux-form'

import { AdverseActionReason } from './types'
import { CheckboxGroup } from '../../components/inputs'
import LoaderButton from '../../components/loaderButton'
import { ReduxFormProps } from '../../forms'

export type Callback<T = void> = (...args: any) => T

interface Props {
  adminStatus: string
  adverseActionReasons: AdverseActionReason[]
  cancel: Callback
}

interface FormProps {
  adverseActions: string[]
}

export class AdverseActionsForm extends Component<
  ReduxFormProps<Props, FormProps>
> {
  render() {
    const {
      adverseActionReasons,
      handleSubmit,
      submitting,
      cancel,
      adminStatus,
    } = this.props

    let disabled = adminStatus === 'EXPIRED'

    const options = adverseActionReasons.map(({ name, description }) => ({
      label: description,
      value: name,
    }))

    return (
      <form className="form" name="adverseActionForm" onSubmit={handleSubmit}>
        <div className="adverse-actions__form">
          <CheckboxGroup name="adverseActions" gridRow options={options} />

          <div className="form__group adverse-actions__form__button">
            <LoaderButton
              type="submit"
              disabled={disabled}
              className={classnames('button __form__button--submit', {
                'button--primary': !disabled,
                'button--disabled': disabled,
              })}
              isLoading={submitting}
            >
              Set Adverse Actions
            </LoaderButton>
            <a
              onClick={cancel}
              className="button button--secondary adverse-actions__form__button--cancel"
              aria-label="cancel"
            >
              Cancel
            </a>
          </div>
        </div>
      </form>
    )
  }
}

export default reduxForm<FormProps, Props>({
  form: 'adverseActionsForm',
  enableReinitialize: true,
  destroyOnUnmount: true,
})(AdverseActionsForm)
